<div class="category-table custom-datatable transcation-datatable">

  <!-- ====================================================== -->
  <!-- TABLA -->
  <!-- ====================================================== -->

  <div class="table-container">

    <div class="table-responsive table-responsive-actions">

      <table class="table table-modern w-100">

        <caption class="visually-hidden">
          Componente tabla
        </caption>

        <!-- ================================================== -->
        <!-- HEADER -->
        <!-- ================================================== -->

        <thead>

          <tr>

            <th class="col-index">
              #
            </th>

            <th scope="col" *ngFor="let header of headers">

              {{ header.label }}

            </th>

            <th scope="col" *ngIf="actions.length > 0" class="col-actions">

              Acciones

            </th>

          </tr>

        </thead>


        <!-- ================================================== -->
        <!-- BODY -->
        <!-- ================================================== -->

        <tbody>


          <!-- ================================================= -->
          <!-- LOADING -->
          <!-- ================================================= -->

          <tr *ngIf="loading">

            <td [attr.colspan]="totalColumns" class="table-loading">

              <app-spinner-loading></app-spinner-loading>

            </td>

          </tr>


          <!-- ================================================= -->
          <!-- DATOS -->
          <!-- ================================================= -->

          <ng-container *ngIf="!loading && paginatedData?.length > 0; else noData">

            <tr *ngFor="let item of paginatedData; let i = index" class="row-hover">


              <!-- ÍNDICE -->

              <th scope="row" class="col-index">

                {{ getIndex(i) }}

              </th>


              <!-- COLUMNAS -->

              <td *ngFor="let header of headers" class="cell-ellipsis" [attr.title]="item[header.key]">

                <span [ngClass]="
                    header.key === 'estado' && item?.clase
                      ? 'tag-solicitud ' + item.clase
                      : null
                  ">

                  {{ item[header.key] }}

                </span>

              </td>


              <!-- ================================================= -->
              <!-- ACCIONES -->
              <!-- ================================================= -->

              <td *ngIf="actions?.length > 0" class="col-actions">

                <div class="table-actions">


                  <!-- ============================================= -->
                  <!-- MENOS DE 3 ACCIONES -->
                  <!-- ============================================= -->

                  <ng-container *ngIf="getVisibleActions(item).length < 3">

                    <ng-container *ngFor="let action of getVisibleActions(item)">

                      <a href="javascript:void(0)" class="action-pill action-pill--sm" [ngClass]="getActionColorClass(action, item)"
                        (click)="onActionClick(action, item)" [attr.aria-label]="action.label"
                        [attr.title]="action.label" *ngIf="!action.visible || action.visible(item)">

                        <i [ngClass]="getActionIcon(action, item)"></i>

                      </a>

                    </ng-container>

                  </ng-container>


                  <!-- ============================================= -->
                  <!-- 3 O MÁS ACCIONES -->
                  <!-- ============================================= -->

                  <ng-container *ngIf="getVisibleActions(item).length >= 3">

                    <div ngbDropdown container="body" class="d-inline-block">


                      <!-- TRES PUNTOS -->

                      <button type="button" class="action-pill action-pill--sm action-more" ngbDropdownToggle
                        aria-label="Más acciones" title="Más acciones">

                        <i class="fa-solid fa-ellipsis-vertical"></i>

                      </button>


                      <!-- DROPDOWN -->

                      <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end action-dropdown">

                        <ng-container *ngFor="let action of getVisibleActions(item)">

                          <button ngbDropdownItem (click)="onActionClick(action, item)">

                            <span class="dropdown-action-icon" [ngClass]="getActionColorClass(action, item)">

                              <i [ngClass]="getActionIcon(action, item)"></i>

                            </span>

                            <span>
                              {{ action.label }}
                            </span>

                          </button>

                        </ng-container>

                      </div>

                    </div>

                  </ng-container>

                </div>

              </td>

            </tr>

          </ng-container>


          <!-- ================================================= -->
          <!-- SIN DATOS -->
          <!-- ================================================= -->

          <ng-template #noData>

            <tr *ngIf="!loading">

              <td [attr.colspan]="totalColumns" class="empty-state-cell">

                <div class="empty-state">

                  <div class="empty-state-icon">

                    <i class="fa-solid fa-inbox"></i>

                  </div>

                  <span class="empty-state-title">
                    No hay datos disponibles
                  </span>

                  <span class="empty-state-description">
                    No se encontraron registros para mostrar.
                  </span>

                </div>

              </td>

            </tr>

          </ng-template>

        </tbody>

      </table>

    </div>

  </div>


  <!-- ====================================================== -->
  <!-- PAGINADOR -->
  <!-- ====================================================== -->

  <div class="table-footer" *ngIf="paginator">


    <!-- ==================================================== -->
    <!-- INFORMACIÓN -->
    <!-- ==================================================== -->

    <div class="table-results-info">

      <span>
        Mostrando

        <strong>
          {{ ((currentPage - 1) * selectedPageSize) + 1 }}
        </strong>

        al

        <strong>
          {{
          (currentPage * selectedPageSize > totalItems)
          ? totalItems
          : currentPage * selectedPageSize
          }}
        </strong>

        de

        <strong>
          {{ totalItems }}
        </strong>

        registros
      </span>

    </div>


    <!-- ==================================================== -->
    <!-- CONTROLES -->
    <!-- ==================================================== -->

    <div class="table-pagination-controls">


      <!-- ================================================== -->
      <!-- PAGINACIÓN -->
      <!-- ================================================== -->

      <nav aria-label="Paginación" class="pagination-modern-wrap">

        <ul class="pagination pagination-modern">


          <!-- =============================================== -->
          <!-- PRIMERA PÁGINA -->
          <!-- =============================================== -->

          <li class="page-item" [class.disabled]="currentPage === 1">

            <a class="page-dot" role="button" aria-label="Primera página" (click)="onPageChange(1)">

              <i class="fa-solid fa-angles-left"></i>

            </a>

          </li>


          <!-- =============================================== -->
          <!-- ANTERIOR -->
          <!-- =============================================== -->

          <li class="page-item" [class.disabled]="currentPage === 1">

            <a class="page-dot" role="button" aria-label="Página anterior" (click)="onPageChange(currentPage - 1)">

              <i class="fa-solid fa-angle-left"></i>

            </a>

          </li>


          <!-- =============================================== -->
          <!-- PÁGINAS -->
          <!-- =============================================== -->

          <ng-container *ngIf="totalPages > 0">

            <ng-container *ngFor="let pageNumber of getPageNumbers()">


              <!-- ELLIPSIS -->

              <li *ngIf="pageNumber === '...'" class="page-item disabled">

                <span class="page-dot page-dot--ellipsis" aria-hidden="true">

                  …

                </span>

              </li>


              <!-- NÚMERO -->

              <li *ngIf="pageNumber !== '...'" class="page-item" [class.active]="pageNumber === currentPage">

                <a class="page-dot" role="button" [attr.aria-current]="
                    pageNumber === currentPage
                      ? 'page'
                      : null
                  " (click)="onPageChange(pageNumber)">

                  {{ pageNumber }}

                </a>

              </li>

            </ng-container>

          </ng-container>


          <!-- =============================================== -->
          <!-- SIGUIENTE -->
          <!-- =============================================== -->

          <li class="page-item" [class.disabled]="
              currentPage === totalPages ||
              totalPages === 0
            ">

            <a class="page-dot" role="button" aria-label="Página siguiente" (click)="onPageChange(currentPage + 1)">

              <i class="fa-solid fa-angle-right"></i>

            </a>

          </li>


          <!-- =============================================== -->
          <!-- ÚLTIMA PÁGINA -->
          <!-- =============================================== -->

          <li class="page-item" [class.disabled]="
              currentPage === totalPages ||
              totalPages === 0
            ">

            <a class="page-dot" role="button" aria-label="Última página" (click)="onPageChange(totalPages)">

              <i class="fa-solid fa-angles-right"></i>

            </a>

          </li>
        </ul>

      </nav>


      <!-- ================================================== -->
      <!-- ESTADO DE PÁGINA -->
      <!-- ================================================== -->

      <div class="page-status">

        Página

        <strong>
          {{ currentPage }}
        </strong>

        de

        <strong>
          {{ totalPages > 0 ? totalPages : 0 }}
        </strong>

      </div>


      <!-- ================================================== -->
      <!-- TAMAÑO DE PÁGINA -->
      <!-- ================================================== -->

      <div class="page-size-select" [class.disabled]="totalPages === 0">

        <label for="pageSize" class="visually-hidden">

          Ítems por página

        </label>


        <select id="pageSize" class="form-select select-pill" [(ngModel)]="selectedPageSize"
          (change)="onPageSizeChange()">

          <option *ngFor="let size of pageSizes" [ngValue]="size">

            {{ size }} ítems

          </option>

        </select>


        <i class="fa-solid fa-chevron-down select-caret" aria-hidden="true">
        </i>

      </div>

    </div>

  </div>

</div>